'use strict';

import { signupState, signupVerificationState } from './signup.states';

import { SignupComponent } from './signupForm/signup.component';
import { SignupVerificationComponent } from './signupVerification/signupFormVerification.component';
import { SignupService } from './signup.service';

export const signUpModule = angular
	.module('mx.sb.signup', [])
	.component(signupState.component, SignupComponent)
	.component(signupVerificationState.component, SignupVerificationComponent)
	.service('mx.sb.SignupService', SignupService)
	.config(signUpConfig);

signUpConfig.$inject = ['$uiRouterProvider'];
function signUpConfig($uiRouterProvider) {
	$uiRouterProvider.stateRegistry.register(signupState);
	$uiRouterProvider.stateRegistry.register(signupVerificationState);
}
